import React, { useState, useContext } from 'react';

// First create the context.
// The default value is no-ops / empty state so consumers don't crash when
// rendered outside of a StateHolder provider (e.g. unit tests).
const MyContext = React.createContext({
  cartItems: [],
  setCartItems: () => {},
  openAuthModal: false,
  setOpenAuthModal: () => {},
  authType: 'signup',
  setAuthType: () => {},
  authContinuation: null,
  setAuthContinuation: () => {},
});

// Then create a StateHolder wrapper component
// to hold the state that the components need.

const StateHolder = props => {
  const [cartItems, setCartItems] = useState([]);
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const [authType, setAuthType] = useState('signup');
  // What the modal does once the guest is signed in: { to } a page to go on to, { then } an
  // action (open the message window), or null
  const [authContinuation, setAuthContinuation] = useState(null);

  return (
    <MyContext.Provider
      value={{
        cartItems,
        setCartItems,
        openAuthModal,
        setOpenAuthModal,
        authType,
        setAuthType,
        authContinuation,
        setAuthContinuation,
      }}
    >
      {props.children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => useContext(MyContext);

export default StateHolder;
